export const IMPLEMENTATION = {
  value: "IMPLEMENTATION",
  key: "status.implementation",
};
export const ACTIVE = {
  value: "ACTIVE",
  key: "status.active",
};
export const INACTIVE = {
  value: "INACTIVE",
  key: "status.inactive",
};

export const TERMINATED = {
  value: "TERMINATED",
  key: "status.terminated",
};

export const PLANNED_INACTIVE = {
  value: "PLANNED_INACTIVE"
};

export const RESTRICTED_STATUSES = [TERMINATED.value, INACTIVE.value];

export default [IMPLEMENTATION, ACTIVE, INACTIVE, TERMINATED];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/enums/clientStatusTypes.js